module.exports = __webpack_public_path__ + "img/icon-white-22.2420ee5f.svg";